<template>
</template>

<script>
export default {
  created: function() {
    // Redirect outside the app using plain old javascript
    window.location.href = "/static/404-not-found.html";
  }
}
</script>



// WEBPACK FOOTER //
// PageNotFound.vue?4864f9bd